import React, { Component } from "react"
import { Dialog, FlatButton, SelectField, MenuItem, CircularProgress, TextField, Toggle } from "material-ui"
import ClearIcon from "material-ui/svg-icons/content/clear"
import ContentFilterList from "material-ui/svg-icons/content/filter-list"
import * as api from "../../../api"
import _ from "lodash"
import strings from "../../../localization/strings"
import { ISchedulePatternTemplate, IWorkPoolEmployee, WorkPoolEmployeeSearchParams } from "../../../models"
import { ERequiresCompletedBadges, CandidatesFilter, IFilter } from "../../../pages/jobs/job-details/job-detail-worker-pool/worker-pool-detail/CandidatesFilter"
import ShortlistSelectionTable from "../../../pages/jobs/job-details/job-detail-worker-pool/worker-pool-detail/ShortlistSelectionTable"
import AppStateStore from "../../../stores/AppStateStore"
import AccountStore from "../../../stores/AccountStore"

enum DefaultFilterValues {
    CREATE_NEW = "0",
    NONE = "1"
}
interface IState {
    employees: IWorkPoolEmployee[]
    totalEmployees: number
    offset: number
    limit: number
    loading: boolean
    selectedFilter: string
    filters: IFilter[]
    selectedEmployees: IWorkPoolEmployee[]
    openFilter: boolean
    editStatus: boolean
    editData: IFilter
    searchParams: Partial<WorkPoolEmployeeSearchParams>
    searchText: string
    filterByActive: boolean
}

interface IProps {
    open: boolean
    assignPatternTemplateId: string
    onClose(): void
    updateWorkPoolEmployeesList(workPoolEmployees: IWorkPoolEmployee[]): void
    replaceSchedulePatternTemplate(schedulePatternTemplate: ISchedulePatternTemplate): void
}

export class AddShortListedCandidate extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            employees: [],
            totalEmployees: 0,
            offset: 0,
            limit: 20,
            loading: false,
            selectedFilter: localStorage.getItem("selectedFilter") || DefaultFilterValues.CREATE_NEW,
            filters: JSON.parse(localStorage.getItem("filters")) || [],
            selectedEmployees: [],
            openFilter: false,
            editStatus: false,
            editData: {
                Id: "",
                Name: "",
                MatchOccupation: false,
                MatchSpecialty: false,
                RequireBagdeMatch: false,
                RequiresCompletedBadges: ERequiresCompletedBadges.YES,
                EmployeeStatusIds: []
            },
            searchParams: JSON.parse(localStorage.getItem("searchParams")) || {},
            searchText: "",
            filterByActive: false
        }
    }

    componentDidMount() {
        if (this.state.selectedFilter.length > 1) this.handleFilterSelection(this.state.selectedFilter, this.state.filters.find((x) => x.Id === this.state.selectedFilter))
        else this.fetchCandidates()
    }

    saveFilter = (filter: IFilter) => {
        this.setState({ filters: [...this.state.filters, filter], openFilter: false }, () => {
            localStorage.setItem("filters", JSON.stringify(this.state.filters))
        })
        this.handleFilterSelection(filter.Id, filter)
        AppStateStore.setProgressSnackbarContent("Filter Saved")
    }

    updateFilter = (filter: IFilter) => {
        this.setState({ filters: this.state.filters.map((x) => (x.Id === filter.Id ? { ...filter } : x)), openFilter: false }, () => {
            localStorage.setItem("filters", JSON.stringify(this.state.filters))
        })
        this.handleFilterSelection(filter.Id, filter)
        AppStateStore.setProgressSnackbarContent("Filter Updated")
    }

    fetchCandidates = () => {
        localStorage.setItem("searchParams", JSON.stringify(this.state.searchParams))
        localStorage.setItem("selectedFilter", this.state.selectedFilter)

        this.setState({ loading: true }, () => {
            api.getWorkPoolEmployeesByShiftId(this.props.assignPatternTemplateId, {
                ...this.state.searchParams,
                SearchTerm: this.state.searchText,
                Limit: this.state.limit,
                Page: this.state.offset / this.state.limit,
                AccountId: AccountStore.getCurrentAccount().Id,
                ShowInactive: this.state.filterByActive
            }).then((response) => {
                this.setState({ employees: response.data.Documents, totalEmployees: response.data.TotalDocumentCount, loading: false })
            })
        })

    }

    handleFilterChange = (id: string) => {
        switch (id) {
            case DefaultFilterValues.CREATE_NEW:
                this.setState({ editStatus: false, selectedFilter: DefaultFilterValues.CREATE_NEW, searchParams: {}, openFilter: true }, () => {
                    this.fetchCandidates()
                })
                break
            case DefaultFilterValues.NONE:
                this.setState({ editStatus: false, selectedFilter: DefaultFilterValues.NONE, searchParams: {} }, () => {
                    this.fetchCandidates()
                })
                break
            default:
                this.handleFilterSelection(id, this.state.filters.find((x) => x.Id === id))
        }
    }

    handleFilterSelection = (filterId: string, filter: IFilter) => {
        const { MatchOccupation, MatchSpecialty, RequireBagdeMatch, RequiresCompletedBadges, EmployeeStatusIds } = filter
        this.setState(
            {
                selectedFilter: filterId,
                editStatus: true,
                editData: filter,
                searchParams: {
                    MatchOccupation: MatchOccupation ? true : null,
                    MatchSpecialty: MatchSpecialty ? true : null,
                    RequireBagdeMatch: RequireBagdeMatch ? true : null,
                    RequiresCompletedBadges: RequireBagdeMatch ? (RequiresCompletedBadges === ERequiresCompletedBadges.YES ? true : false) : null,
                    EmployeeStatusFilters: EmployeeStatusIds
                        .filter(x => (x.Status && x.Status.Id) || (x.SubStatus && x.SubStatus.Id))
                        .map((x) => ({
                            StatusId: x.Status.Id,
                            SubStatusId: x.SubStatus.Id
                        }))
                }
            },
            () => {
                this.fetchCandidates()
            }
        )
    }

    shortListCandidates = async () => {
        const selectedEmployeeIDs = this.state.selectedEmployees.map((item) => item.Id)
        AppStateStore.setProgressSnackbarContent("loading")
        api.shortListSelectedShiftCandidates(this.props.assignPatternTemplateId, { userIds: selectedEmployeeIDs })
            .then((response) => {
                this.props.replaceSchedulePatternTemplate &&
                    this.props.replaceSchedulePatternTemplate(response.data as ISchedulePatternTemplate)
                this.props.updateWorkPoolEmployeesList(response.data.WorkPoolEmployees)
                this.fetchCandidates()
                this.props.onClose()
                AppStateStore.setProgressSnackbarContent(strings.Successfully_shortlisted)
            })
            .catch(err =>
                AppStateStore.setProgressSnackbarContent(err.response.data.message)
            )
    }

    render() {
        const { open, onClose } = this.props
        const { employees, selectedFilter, filters, selectedEmployees, openFilter, editData, editStatus, totalEmployees } = this.state

        return (
            <Dialog
                contentStyle={{ width: "80%", maxWidth: "none" }}
                autoScrollBodyContent
                open={open}
                title={strings.User_Match_Filter}
                titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
                actions={[
                    <FlatButton label={strings.CANCEL} secondary onClick={onClose} />,
                    <FlatButton label={strings.Add_To_Shortlist} primary disabled={!selectedEmployees.length} onClick={this.shortListCandidates} />
                ]}
            >
                <div style={{ display: "flex", alignItems: "center" }}>
                    <ContentFilterList style={{ cursor: "pointer", width: "30px", marginRight: "10px" }} onClick={() => this.setState({ openFilter: true })} />
                    <SelectField
                        floatingLabelText={"Filter Template"}
                        value={selectedFilter}
                        onChange={(event, key, state) => {
                            this.handleFilterChange(state)
                        }}
                        style={{ width: 300 }}
                    >
                        <MenuItem value={DefaultFilterValues.CREATE_NEW} primaryText={"Create New..."} />
                        <MenuItem value={DefaultFilterValues.NONE} primaryText={"None"} />
                        {filters.map((filter) => (
                            <MenuItem key={filter.Id} value={filter.Id} primaryText={filter.Name} />
                        ))}
                    </SelectField>
                </div>
                <div>
                    <br></br>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        {/* Employee Search */}
                        <div style={{ flexGrow: 1 }}>
                            <i style={{ fontSize: 25 }} className="fa fa-search" />
                            <TextField
                                hintText={strings.Search}
                                style={{ marginRight: 20, width: "91%", marginLeft: 15 }}
                                value={this.state.searchText}
                                onChange={e => this.setState({ searchText: e.target.value, offset: 0 }, _.debounce(() => this.fetchCandidates(), 1000))}
                            />
                            {this.state.searchText !== "" && (
                                <ClearIcon style={{ marginBottom: -15, cursor: "pointer" }} onClick={() => this.setState({ searchText: "" }, () => this.fetchCandidates())} />
                            )}
                        </div>
                        {/* Employee Toggle Active */}
                        <div>
                            <Toggle
                                toggled={this.state.filterByActive}
                                onToggle={(e, value) => this.setState({ filterByActive: !this.state.filterByActive }, () => this.fetchCandidates())}
                                labelPosition="left"
                                label={strings.Show_Inactive}
                                style={{ maxWidth: 200, marginRight: 35 }}
                            />
                        </div>
                    </div>
                    <div style={{ padding: 20 }}>
                        {this.state.loading ? (
                            <div className="spinner">
                                <CircularProgress />
                            </div>
                        ) : (
                            <div>
                                {!employees.length ? (
                                    <h2 style={{ textAlign: "center", marginTop: 25 }}>{strings.No_employee_found}</h2>
                                ) : (
                                    <ShortlistSelectionTable
                                        readonly={false}
                                        workPoolEmployees={employees}
                                        selectedEmployees={selectedEmployees}
                                        total={totalEmployees}
                                        offset={this.state.offset}
                                        limit={this.state.limit}
                                        limitOptions={[20, 50, 100]}
                                        onPageClick={(offset) => this.setState({ offset }, () => this.fetchCandidates())}
                                        onLimitChange={(limit) => this.setState({ offset: 0, limit }, () => this.fetchCandidates())}
                                        handleSelect={(selectedEmployees) => this.setState({ selectedEmployees })}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {openFilter && (
                    <CandidatesFilter
                        open={openFilter}
                        onClose={() => this.setState({ openFilter: false })}
                        edit={editStatus}
                        editData={editData}
                        saveFilter={this.saveFilter}
                        updateFilter={this.updateFilter}
                        existingFilters={filters}
                    />
                )}
            </Dialog>
        )
    }
}

export default AddShortListedCandidate
